export const getWeekStartDate = (date = new Date()) => {
  const d = new Date(date);
  const day = d.getUTCDay();
  const diff = d.getUTCDate() - day + (day === 0 ? -6 : 1); // понедельник
  d.setUTCDate(diff);
  d.setUTCHours(0, 0, 0, 0);
  return d;
};

export const getWeekRange = (date = new Date()) => {
  const start = getWeekStartDate(date);
  const end = new Date(start);
  end.setUTCDate(start.getUTCDate() + 6);
  return { start, end };
};

 export const isSameWeek = (date1, date2) => {
   return getWeekStartDate(date1).getTime() === getWeekStartDate(date2).getTime();
 };